// extracted by mini-css-extract-plugin
export default {"buttons":"Contact_buttons__iJSLb","warning":"Contact_warning__oDqgb","contact":"Contact_contact__HZvCY","footer":"Contact_footer__Isd-0"};